export enum ApplicationType {
  NORMAL = 'NORMAL',
  EXPRESS = 'EXPRESS',
  POS = 'POS',
}